import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import SourceModePill from 'components/AI/CanonicalPicker/SourceModePill'
import {
  CanonicalLevel,
  PickerSliceState,
  selectActiveSource,
  selectGroupConfig,
  sourceChoiceOf,
} from 'slices/aiSegmentBuilder/picker'

type RootState = { picker: PickerSliceState }

type Props = {
  pickerId: number
  level: CanonicalLevel
}

/** The mode pill of one level of a card; nothing for a level with no choice of source */
const LevelModePillContainer = ({ pickerId, level }: Props) => {
  const config = useSelector(
    (state: RootState) => selectGroupConfig(state, pickerId)[level]
  )
  const activeSource = useSelector((state: RootState) =>
    selectActiveSource(state, pickerId, level)
  )
  const choice = useMemo(() => sourceChoiceOf(config), [config])
  if (!choice) return null

  return <SourceModePill isSpecific={activeSource === choice.specific.name} />
}

export default LevelModePillContainer
